import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore } from '../../store/applicationStore';
import { iframeService } from '../iframeService';

export const PlatformMessagesWrapper = observer(({ children = [], additionalMessagesParams }) => {
  const { isAuthDataReceived } = applicationStore;

  useEffect(() => {
    iframeService.setPostMessageListener(additionalMessagesParams);
    iframeService.sendGetAuthInfo();
  }, [additionalMessagesParams]);

  return isAuthDataReceived ? children : null;
});
